export const COMMUNICATION_CONSENT = 'Communications';
export const TERMS_AND_PRIVACY_CONSENT = 'TermsAndPrivacy';
export const FULL_CONSENT = 'FULL_CONSENT';

export const ALL_CONSENTS = [COMMUNICATION_CONSENT, TERMS_AND_PRIVACY_CONSENT, FULL_CONSENT];

export interface ConsentInput {
  type: typeof COMMUNICATION_CONSENT | typeof TERMS_AND_PRIVACY_CONSENT | typeof FULL_CONSENT;
  consentAt: Date;
}

export interface Consent extends ConsentInput {
  id: string;
}
